"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorOptionalExtrasWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var OptionalExtra_1 = require("./OptionalExtra");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var services_1 = require("@falcon/services");
var journey_services_1 = require("@athena-portal/journey-services");
var NcdInfoSection_1 = require("./NcdInfoSection");
var commonFunctions_1 = require("../../../../commonFunctions");
var modals = require("../tierTable/TierTableInfoModalRenderers");
var AnnualMotorTierUpgradeModalConditions_1 = require("../../../../helpers/annual/motor/AnnualMotorTierUpgradeModalConditions");
var AnnualMotorTierUpgradeModals_1 = require("../../../../helpers/annual/motor/AnnualMotorTierUpgradeModals");
var ProtectedNcdOptionalExtra = function (_a) {
    var _b = _a.interaction, policyHolder = _b.policyHolder, optionalExtras = _b.optionalExtras, factors = _b.factors, onAdd = _a.onAdd, onRemove = _a.onRemove;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var isAdded = policyHolder.ncd.doNotDisclose;
    var addonState = getOptionalExtrasState(policyHolder.ncd.doNotDisclose);
    return (React.createElement(OptionalExtra_1.default, { id: "optional-extra-protected-ncd", added: isAdded },
        React.createElement("div", { className: "optional-extra__title-container" },
            React.createElement("div", { className: "optional-extra__img" }),
            React.createElement("div", { className: "optional-extra-title-wrapper" },
                React.createElement(OptionalExtra_1.OptionalExtraTitle, { isOptionalExtraAdded: isAdded }, "Protected no claims discount"),
                React.createElement(NcdInfoButton, null))),
        React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement(NcdPriceSection, { isMonthly: isMonthly, optionalExtras: optionalExtras })),
        React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-protected-ncd", onClick: onAdd, className: addonState.cssClass }, addonState.addWording),
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-protected-ncd-no-thanks", isActive: addonState.isActive, onClick: onRemove }, addonState.removeWording))));
};
var getOptionalExtrasState = function (optionalExtrasField) {
    var addonState = {};
    addonState.isActive = optionalExtrasField || optionalExtrasField === false;
    addonState.cssClass = optionalExtrasField ? "optional-extra-toggle-button--added" : "optional-extra-toggle-button--add";
    addonState.addWording = optionalExtrasField ? "Added" : "Add";
    var declineWording = optionalExtrasField === false ? "Not added" : "No, thanks";
    addonState.removeWording = optionalExtrasField ? "Remove" : declineWording;
    return addonState;
};
var MotorLegalExpensesOptionalExtra = function (_a) {
    var _b = _a.interaction, optionalExtras = _b.optionalExtras, factors = _b.factors, coverTier = _b.coverTier, onAdd = _a.onAdd, onRemove = _a.onRemove;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var isAllianzTier = coverTier === "ALLIANZ" || !coverTier;
    var isAdded = optionalExtras.motorLegalExpenses || isAllianzTier;
    var addonState = getOptionalExtrasState(optionalExtras.motorLegalExpenses);
    return (React.createElement(OptionalExtra_1.default, { id: "optional-extra-mle", added: isAdded },
        React.createElement("div", { className: "optional-extra__title-container" },
            React.createElement("div", { className: "optional-extra__img" }),
            React.createElement("div", { className: "optional-extra-title-wrapper" },
                React.createElement(OptionalExtra_1.OptionalExtraTitle, { isOptionalExtraAdded: false }, "Motor legal expenses"),
                React.createElement("div", { className: "optional-extra__info-button-wrapper" },
                    React.createElement(MLEInfoButton, null)))),
        !isAllianzTier && React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement(MlePriceSection, { isMonthly: isMonthly, optionalExtras: optionalExtras })),
        !isAllianzTier && React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-mle", onClick: onAdd, className: addonState.cssClass }, addonState.addWording),
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-mle-no-thanks", isActive: addonState.isActive, onClick: onRemove }, addonState.removeWording)),
        isAllianzTier && React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement("div", { className: "optional-extra-included" }, "Included as standard"))));
};
var MLEInfoButton = function () { return (modals.renderMotorLegalExpensesModal()); };
var getCourtesyCarIsAdded = function (coverTier, optionalExtras) {
    switch (coverTier) {
        case services_1.ALLIANZ_ESSENTIALS:
            return optionalExtras.courtesyCar;
        case services_1.ALLIANZ_SILVER:
            return optionalExtras.courtesyCarTotalLoss;
        case services_1.ALLIANZ:
            return true;
        default:
            return false;
    }
};
var getCourtesyCarMapping = function (coverTier, optionalExtras) {
    if (coverTier === services_1.ALLIANZ_SILVER) {
        return optionalExtras.courtesyCarTotalLoss;
    }
    return optionalExtras.courtesyCar;
};
var GuaranteedHireCarOptionalExtra = function (_a) {
    var _b = _a.interaction, optionalExtras = _b.optionalExtras, factors = _b.factors, coverTier = _b.coverTier, onAdd = _a.onAdd, onRemove = _a.onRemove;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var isAllianzTier = coverTier === "ALLIANZ" || !coverTier;
    var isSilverTier = coverTier === "ALLIANZ_SILVER";
    var isAdded = Boolean(getCourtesyCarIsAdded(coverTier, optionalExtras));
    var addonState = getOptionalExtrasState(getCourtesyCarMapping(coverTier, optionalExtras));
    return (React.createElement(OptionalExtra_1.default, { id: "optional-extra-ghc", added: isAdded },
        React.createElement("div", { className: "optional-extra__title-container" },
            React.createElement("div", { className: "optional-extra__img" }),
            React.createElement("div", { className: "optional-extra-title-wrapper" },
                React.createElement(OptionalExtra_1.OptionalExtraTitle, { isOptionalExtraAdded: false }, isSilverTier ? "Guaranteed hire car if your car's stolen or written off" : "Guaranteed hire car if you car's stolen, written off or being repaired"),
                React.createElement("div", { className: "optional-extra__info-button-wrapper" },
                    React.createElement(GHCInfoButton, null)))),
        !isAllianzTier &&
            React.createElement("div", { className: "optional-extra__price-container position-relative" },
                React.createElement(GhcPriceSection, { isMonthly: isMonthly, optionalExtras: optionalExtras, coverTier: coverTier })),
        !isAllianzTier && (React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-mle", onClick: onAdd, className: addonState.cssClass }, addonState.addWording),
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-mle-no-thanks", isActive: addonState.isActive, onClick: onRemove }, addonState.removeWording))),
        isAllianzTier && React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement("div", { className: "optional-extra-included" }, "Included as standard"))));
};
var GHCInfoButton = function () { return (modals.renderGuaranteedHireCarModal()); };
var BreakdownCoverPrice = function (_a) {
    var optionalExtras = _a.optionalExtras, isMonthly = _a.isMonthly, isAdded = _a.isAdded;
    var pricePrefix = isAdded ? "for" : "from";
    switch (optionalExtras.breakdownCoverLevel) {
        case undefined:
        case null:
            return isMonthly
                ? React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month", prefix: pricePrefix }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverLocalMonthlyCost))
                : React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year", prefix: pricePrefix }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverLocalCost));
        case services_1.BreakdownCoverLevelEnum.LOCAL:
            return isMonthly
                ? React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverLocalMonthlyCost))
                : React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverLocalCost));
        case services_1.BreakdownCoverLevelEnum.UK:
            return isMonthly
                ? React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverUkMonthlyCost))
                : React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverUkCost));
        case services_1.BreakdownCoverLevelEnum.EU:
            return isMonthly
                ? React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverEuMonthlyCost))
                : React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.breakdownCoverEuCost));
        default:
            throw new Error("Unknown Breakdown Cover level: ".concat(optionalExtras.breakdownCoverLevel));
    }
};
var breakdownCoverWording = function (breakdownCoverLevel) {
    switch (breakdownCoverLevel) {
        case services_1.BreakdownCoverLevelEnum.LOCAL:
            return "Local";
        case services_1.BreakdownCoverLevelEnum.UK:
            return "National";
        case services_1.BreakdownCoverLevelEnum.EU:
            return "European";
        default:
            throw new Error("Unknown Breakdown Cover level: ".concat(breakdownCoverLevel));
    }
};
var BreakdownCoverInfoButton = function () { return (modals.renderBreakDownCoverModal()); };
var BreakdownCoverOptionalExtra = function (_a) {
    var _b = _a.interaction, optionalExtras = _b.optionalExtras, factors = _b.factors, onChange = _a.onChange, onEdit = _a.onEdit, onDeny = _a.onDeny;
    var isAdded = optionalExtras.breakdownCover && optionalExtras.breakdownCoverLevel;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var omegaBreakdownRebranding = process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED ? JSON.parse(process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED) : false;
    return (React.createElement(OptionalExtra_1.default, { id: "optional-extra-breakdown-cover", added: isAdded },
        React.createElement("div", { className: "optional-extra__title-container" },
            React.createElement("div", { className: "br-breakdown-header" },
                React.createElement("div", { className: "optional-extra__img" }),
                React.createElement("div", { className: "optional-extra-title-wrapper" },
                    React.createElement(OptionalExtra_1.OptionalExtraTitle, { isOptionalExtraAdded: isAdded }, "Breakdown cover"),
                    React.createElement(BreakdownCoverInfoButton, null))),
            omegaBreakdownRebranding && React.createElement("div", { className: "br-logo" })),
        isAdded && (React.createElement("div", { className: "selected-breakdown-cover-wrapper" },
            React.createElement("div", { className: "selected-breakdown-cover position-relative text-center mb-1" },
                React.createElement("span", { className: "font-weight-semi-bold" }, breakdownCoverWording(optionalExtras.breakdownCoverLevel))),
            React.createElement("div", { className: "optional-extra__button-container" },
                React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "edit-breakdown-cover", className: "mb-3", isActive: true, onClick: onEdit }, "Edit level of cover")))),
        React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement(BreakdownCoverPrice, { optionalExtras: optionalExtras, isMonthly: isMonthly, isAdded: isAdded })),
        isAdded && (React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "edit-breakdown-cover", className: "optional-extra-toggle-button--added", isActive: false }, "Added"),
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-breakdown-cover-btn", isActive: true, onClick: onChange }, "Remove"))),
        !isAdded && (React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-breakdown-cover-btn", isActive: false, onClick: onChange }, "Add"),
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-breakdown-cover-btn-no-thanks", className: "mt-3", isActive: optionalExtras.breakdownCover || optionalExtras.breakdownCover === false, onClick: onDeny }, optionalExtras.breakdownCover === false ? "Not added" : "No, thanks")))));
};
var FamilyPackageOptionalExtra = function (_a) {
    var _b = _a.interaction, optionalExtras = _b.optionalExtras, factors = _b.factors, onChange = _a.onChange;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var isAdded = optionalExtras.familyPackage;
    return (React.createElement(OptionalExtra_1.default, { id: "optional-extra-family-package", added: isAdded },
        React.createElement("div", { className: "optional-extra__title-container" },
            React.createElement(OptionalExtra_1.OptionalExtraImage, { src: "/".concat(services_1.resourcesHelper.THEME, "/img/car-seat.png"), alt: "Child car seat" }),
            React.createElement("div", { className: "optional-extra-title-wrapper" },
                React.createElement(OptionalExtra_1.OptionalExtraTitle, { isOptionalExtraAdded: isAdded }, "Family package"),
                React.createElement(FamilyPackageInfoButton, null))),
        React.createElement("div", { className: "optional-extra__price-container position-relative" },
            React.createElement(FamilyPackagePriceSection, { isMonthly: isMonthly, optionalExtras: optionalExtras })),
        React.createElement("div", { className: "optional-extra__button-container" },
            React.createElement(OptionalExtra_1.OptionalExtraToggleButton, { id: "optional-extra-family-package", isActive: isAdded, onClick: onChange }, isAdded ? "Remove" : "Yes, please"))));
};
var FamilyPackageInfoButton = function () { return (React.createElement(OptionalExtra_1.OptionalExtraInfo, { title: "Family package" },
    React.createElement("div", { className: "mb-2" },
        React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "Replacement child car seats"),
        React.createElement("p", { className: "mb-0 font-weight-extra-light" }, "If your car\u2019s been stolen or damaged, we\u2019ll provide new child seats, even if there\u2019s no apparent damage to them. Safety first!")),
    React.createElement("div", { className: "mb-2" },
        React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "\u00A3500 to continue your journey "),
        React.createElement("p", { className: "mb-0 font-weight-extra-light" }, "If you\u2019re over 25 miles from where your journey began and your car can\u2019t be driven following a claim\u2026 fear not! We\u2019ll reimburse you up to \u00A3500 in all for alternative travel and overnight accommodation, if you need it. Just give us your receipts.")),
    React.createElement("div", null,
        React.createElement("p", { className: "mb-0 font-weight-semi-bold" }, "Your non manufacturer fitted in-car equipment, covered "),
        React.createElement("p", { className: "mb-0 font-weight-extra-light" },
            "We'll pay up to \u00A31,000 for fitted or portable equipment even if it wasn't fitted by the car's manufacturer. That's entertainment!",
            React.createElement("br", null),
            "For equipment that was fitted by the car's manufacturer when your car was first registered, you have unlimited replacement cover included as standard already.")))); };
var NcdInfoButton = function () { return (React.createElement(OptionalExtra_1.OptionalExtraInfo, { title: "Protected no claims discount" },
    React.createElement(NcdInfoSection_1.NcdInfoSection, null))); };
var FamilyPackagePriceSection = function (_a) {
    var isMonthly = _a.isMonthly, optionalExtras = _a.optionalExtras;
    if (isMonthly) {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.familyPackageMonthlyCost))));
    }
    else {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.familyPackageCost))));
    }
};
var NcdPriceSection = function (_a) {
    var isMonthly = _a.isMonthly, optionalExtras = _a.optionalExtras;
    if (isMonthly) {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.protectedNcdMonthlyCost))));
    }
    else {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.protectedNcdCost))));
    }
};
var MlePriceSection = function (_a) {
    var isMonthly = _a.isMonthly, optionalExtras = _a.optionalExtras;
    if (isMonthly) {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "month" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.motorLegalExpensesMonthlyCost))));
    }
    else {
        return (React.createElement("div", null,
            React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: "year" }, (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.motorLegalExpensesCost))));
    }
};
var GhcPriceSection = function (_a) {
    var isMonthly = _a.isMonthly, optionalExtras = _a.optionalExtras, coverTier = _a.coverTier;
    return (React.createElement("div", null,
        React.createElement(OptionalExtra_1.OptionalExtraPrice, { per: isMonthly ? "month" : "year" }, getCourtesyCarCost(isMonthly, optionalExtras, coverTier))));
};
var MTANotification = function (_a) {
    var _b = _a.interaction, status = _b.status, factors = _b.factors;
    var isMonthly = factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
    var isMta = status === services_1.INTERACTION_STATUS_PENDING_MTA;
    if (isMta) {
        return (isMonthly ?
            React.createElement("div", null, "See below your monthly price if you'd added this cover from the start of your policy.") :
            React.createElement("div", null, "See below the annual price if you'd added this cover from the start of your policy."));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
function getCourtesyCarCost(isMonthly, optionalExtras, coverTier) {
    if (coverTier === services_1.ALLIANZ_SILVER) {
        return isMonthly ?
            (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.courtesyCarTotalLossMonthlyCost) :
            (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.courtesyCarTotalLossCost);
    }
    return isMonthly ?
        (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.courtesyCarMonthlyCost) :
        (0, commonFunctions_1.getAmountToDisplay)(optionalExtras.courtesyCarCost);
}
var AnnualMotorOptionalExtrasWidget = exports.AnnualMotorOptionalExtrasWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorOptionalExtrasWidget, _super);
    function AnnualMotorOptionalExtrasWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleOptionalExtra = function (interactionField) {
            _this.toggleBooleanInteractionField(interactionField);
            _this.executeChangeEventAfterTimeout();
        };
        _this.addOrRemoveOptionalExtra = function (interactionField, addExtra) {
            if ((addExtra && _this.bindFromField(interactionField) === true) || !addExtra && _this.bindFromField(interactionField) === false) {
                return;
            }
            _this.setOptionalExtraInteractionField(interactionField, addExtra);
            journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", _this.props.interaction, !_this.props.interaction.uistate.interactionChangesDetected);
            addExtra ? !_this.showModal() && _this.executeEvent("change") : _this.executeEvent("change");
        };
        _this.toggleBooleanInteractionField = function (interactionField) {
            _this.changeQuestionValue(interactionField, !_this.bindFromField(interactionField));
        };
        /*
         * This method changes the value of interaction field
         * and makes sure the current interaction state is saved when interaction is saved (i.e. when proceeding to next page)
         */
        _this.changeQuestionValue = function (interactionField, value) {
            _this.props.onStateChange(interactionField, value);
            (0, commonFunctions_1.handleChanged)(interactionField, _this.props.interaction, journey_services_1.ObjectManipulator.fetchFieldValue(interactionField, _this.state.initialAddonState), value);
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.state = {
            showModalEssentialsGHCSelected: false,
            showModalEssentialsMLESelected: false,
            showModalSilverMLESelected: false,
            showModalEssentialsGHCAndMLESelected: false,
            showModalSilverGHCAndMLESelected: false,
            initialAddonState: {
                optionalExtras: {
                    courtesyCar: _this.props.interaction.optionalExtras.courtesyCar,
                    courtesyCarTotalLoss: _this.props.interaction.optionalExtras.courtesyCarTotalLoss,
                    motorLegalExpenses: _this.props.interaction.optionalExtras.motorLegalExpenses,
                    breakdownCover: _this.props.interaction.optionalExtras.breakdownCover,
                    familyPackage: _this.props.interaction.optionalExtras.familyPackage,
                },
                policyHolder: {
                    ncd: {
                        doNotDisclose: _this.props.interaction.policyHolder.ncd.doNotDisclose
                    }
                }
            }
        };
        _this.switchTier = _this.switchTier.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    AnnualMotorOptionalExtrasWidget.prototype.render = function () {
        var _this = this;
        var interaction = this.props.engine.getInteraction();
        var showProtectNcdOptionalExtra = interaction.policyHolder &&
            interaction.policyHolder.ncd &&
            interaction.policyHolder.ncd.yearCount >= 4;
        return (React.createElement(React.Fragment, null,
            React.createElement(MTANotification, { interaction: interaction }),
            React.createElement("div", { id: this.props.question.name, className: "optional-extras-wrapper optional-extras-wrapper--annual-motor optionalExtras" },
                React.createElement(BreakdownCoverOptionalExtra, { interaction: interaction, onChange: function () { return _this.toggleOptionalExtra("optionalExtras.breakdownCover"); }, onEdit: function () { return _this.toggleBooleanInteractionField("uistate.isBreakdownCoverModalOpenForEditing"); }, onDeny: function () { return _this.addOrRemoveOptionalExtra("optionalExtras.breakdownCover", false); } }),
                showProtectNcdOptionalExtra &&
                    React.createElement(ProtectedNcdOptionalExtra, { interaction: interaction, onAdd: function () { return _this.addOrRemoveOptionalExtra("policyHolder.ncd.doNotDisclose", true); }, onRemove: function () { return _this.addOrRemoveOptionalExtra("policyHolder.ncd.doNotDisclose", false); } }),
                React.createElement(MotorLegalExpensesOptionalExtra, { interaction: interaction, onAdd: function () { return _this.addOrRemoveOptionalExtra("optionalExtras.motorLegalExpenses", true); }, onRemove: function () { return _this.addOrRemoveOptionalExtra("optionalExtras.motorLegalExpenses", false); } }),
                React.createElement(GuaranteedHireCarOptionalExtra, { interaction: interaction, onAdd: function () { return _this.addOrRemoveOptionalExtra("optionalExtras.courtesyCarTotalLoss", true); }, onRemove: function () { return _this.addOrRemoveOptionalExtra("optionalExtras.courtesyCarTotalLoss", false); } }),
                services_1.InteractionHelper.isPolicyQuotedBeforeFamilyCoverRemoval(interaction) &&
                    React.createElement(FamilyPackageOptionalExtra, { interaction: interaction, onChange: function () { return _this.toggleOptionalExtra("optionalExtras.familyPackage"); } }),
                (0, AnnualMotorTierUpgradeModals_1.getAnnualMotorTierUpgradeModals)(this.state, this.switchTier, this.closeModal, this.bindFromField.bind(this)))));
    };
    AnnualMotorOptionalExtrasWidget.prototype.setOptionalExtraInteractionField = function (interactionField, addExtra) {
        if (["optionalExtras.courtesyCar", "optionalExtras.courtesyCarTotalLoss"].includes(interactionField)) {
            this.changeQuestionValue("optionalExtras.courtesyCar", addExtra);
            this.changeQuestionValue("optionalExtras.courtesyCarTotalLoss", addExtra);
        }
        else {
            this.changeQuestionValue(interactionField, addExtra);
        }
    };
    AnnualMotorOptionalExtrasWidget.prototype.showModal = function () {
        var conditions = (0, AnnualMotorTierUpgradeModalConditions_1.getModalConditions)(this.bindFromField.bind(this), this.props.interaction);
        var _loop_1 = function (condition) {
            if (!condition.isModalShown && condition.conditionCheck()) {
                this_1.setState(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[condition.stateKey] = true, _a)));
                });
                journey_services_1.ObjectManipulator.setField(condition.uiStateKey, this_1.props.interaction, true);
                return { value: true };
            }
        };
        var this_1 = this;
        for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
            var condition = conditions_1[_i];
            var state_1 = _loop_1(condition);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    AnnualMotorOptionalExtrasWidget.prototype.executeChangeEventAfterTimeout = function () {
        var _this = this;
        setTimeout(function () {
            _this.executeEvent("change");
        }, AnnualMotorOptionalExtrasWidget.timeoutMs);
    };
    AnnualMotorOptionalExtrasWidget.prototype.closeModal = function (modalStateKey) {
        this.setState(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[modalStateKey] = false, _a)));
        });
        this.executeChangeEventAfterTimeout();
    };
    AnnualMotorOptionalExtrasWidget.prototype.switchTier = function (tier, modalStateKey) {
        journey_services_1.ObjectManipulator.setField("coverTier", this.props.interaction, tier);
        journey_services_1.ObjectManipulator.setField("uistate.selectedCoverTier", this.props.interaction, tier);
        this.closeModal(modalStateKey);
    };
    // To be fixed in FAL-40039
    // This is a dirty hack to solve FAL-39979 for deadline without making Athena changes
    // The idea is to execute change event only after typing timeout in Athena passes and interaction changes are processed in PluginJourneyRenderingPage
    AnnualMotorOptionalExtrasWidget.timeoutMs = 100 + (process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT ? parseInt(process.env.REACT_APP_INTERACTION_UPDATE_TIMEOUT, 10) : 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualMotorOptionalExtrasWidget.prototype, "changelogRecorder", void 0);
    return AnnualMotorOptionalExtrasWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualMotorOptionalExtrasWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/optionalExtras/AnnualMotorOptionalExtrasWidget.js
// module id = 1245
// module chunks = 0